<form novalidate [formGroup]="formData" (submit)="handleSubmit($event)">
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label for="" [translate]="'FORM.INPUT.CURRENT_PASSWORD'"
        >Current Password</label
      >
      <div class="input-group">
        <input
          class="form-control"
          [type]="hide ? 'password' : 'text'"
          formControlName="password"
        />
        <div class="input-group-append">
          <button class="btn btn-secondary btn-sm" type="button">
            <mat-icon (click)="hide = !hide"
              >{{ hide ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </button>
        </div>
      </div>
      <control-messages
        [submitted]="submitted"
        [control]="formData.controls.password"
        [minlength]="8"
      >
      </control-messages>
    </div>
    <div class="kt-login__divider">
      <div class="kt-divider">
        <span></span>
        <span>{{ 'FORM.INPUT.NEW_PASSWORD' | translate }}</span>
        <span></span>
      </div>
    </div>
    <div class="form-group">
      <label for="" [translate]="'FORM.INPUT.NEW_PASSWORD'">New Password</label>
      <div class="input-group">
        <input
          class="form-control"
          [type]="hide ? 'password' : 'text'"
          formControlName="new_password"
        />
        <div class="input-group-append">
          <button class="btn btn-secondary btn-sm" type="button">
            <mat-icon (click)="hide = !hide"
              >{{ hide ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </button>
        </div>
      </div>
      <control-messages
        [submitted]="submitted"
        [control]="formData.controls.new_password"
        [minlength]="8"
      >
      </control-messages>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-danger"
      (click)="activeModal.dismiss('')"
      [translate]="'BUTTONS.CLOSE'"
    >
      <i class="fas fa-times"></i> Close
    </button>
    <button
      type="submit"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
      [disabled]="loading"
      id="kt_submit"
      class="btn btn-primary btn-elevate kt-btn-primary"
      [translate]="'BUTTONS.SAVE'"
    >
      <i class="fas fa-save"></i> Save New Password
    </button>
  </div>
</form>
